const PCPReducer = (state = {}, action) => {
    switch (action.type) {
        case "PCPLIST_DOCS":
            return Object.assign({}, state, {
                PCP_ListView: action.data
            });
        case "LOOKUP_PCPACT":
            return Object.assign({}, state, {
                PCPACTIVITY_LOOKUP: action.data
            });
        case "PCP_ADD":
            return Object.assign({}, state, {
                PCP_Add: action.data
            });
        case "PCPEDIT_DOCS":
            return Object.assign({}, state, {
                geteditpcp: action.data
            });
        case "SHARE_PCPFILES":
            return Object.assign({}, state, {
                sharedpcpfile: action.data
            });
        case "SHARE_PCPDATAS":
            return Object.assign({}, state, {
                sharedpcpdata: action.data
            });
        case "ERROR_PCPFILES":
            return Object.assign({}, state, {
                errorpcppass: action.data
            });
        case "PASS_PCPOTHERS":
            return Object.assign({}, state, {
                otherspcpass: action.data
            });
            case "PASS_CANCEL":
            return Object.assign({}, state, {
                pcpcancel: action.data
            });
        default:
            return state;
    }
};

export default PCPReducer;